import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";
import FutureHomeLogo from "./FutureHomeLogo";

const EXPLORE_LINKS = [
  { href: "/#product", label: "Technology" },
  { href: "/#control", label: "Control" },
  { href: "/#applications", label: "Applications" },
  { href: "/#design", label: "Design" },
  { href: "/#energy", label: "Energy" },
  { href: "/#why", label: "Why ecoHeatwave" },
  { href: "/#consultation", label: "Consultation" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ecoh-ink text-white/80">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <FooterBrand />
          <FooterContact />
          <FooterExplore />
        </div>
        <FooterBottom />
      </div>
    </footer>
  );
}

function FooterBrand() {
  return (
    <div className="md:col-span-5">
      <BrandLogo tone="light" size={32} />
      <p className="mt-6 max-w-sm text-white/65 text-base font-light leading-relaxed">
        Invisible radiant heating designed for modern, electrified buildings.
      </p>
    </div>
  );
}

function FooterContact() {
  return (
    <div className="md:col-span-4">
      <div className="text-[11px] tracking-[0.22em] uppercase text-white/50 mb-4">Contact</div>
      <div className="mb-5 -ml-1">
        <FutureHomeLogo />
      </div>
      <ul className="space-y-2 text-white/85 font-light">
        <li data-testid="footer-address">33 Elder Park, Beverley, East Yorkshire</li>
        <li>
          <a
            data-testid="footer-tel"
            href="tel:+443306332911"
            className="hover:text-ecoh-accent transition-colors"
          >
            0330 633 2911
          </a>
        </li>
        <li>
          <a
            data-testid="footer-email"
            href="mailto:info@futurehomesystems.co.uk"
            className="hover:text-ecoh-accent transition-colors"
          >
            info@futurehomesystems.co.uk
          </a>
        </li>
      </ul>
    </div>
  );
}

function FooterExplore() {
  return (
    <div className="md:col-span-3">
      <div className="text-[11px] tracking-[0.22em] uppercase text-white/50 mb-4">Explore</div>
      <ul className="space-y-2 text-white/85 font-light">
        {EXPLORE_LINKS.map((l) => (
          <li key={l.href}>
            {l.route ? (
              <Link to={l.href} className="hover:text-ecoh-accent transition-colors">
                {l.label}
              </Link>
            ) : (
              <a href={l.href} className="hover:text-ecoh-accent transition-colors">
                {l.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

function FooterBottom() {
  return (
    <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-white/50">
      <div className="flex flex-col sm:flex-row gap-4 sm:items-center sm:gap-6">
        <span>© {new Date().getFullYear()} Future Home Systems Limited. All rights reserved.</span>
        <img
          src="/brand/made-in-britain.png"
          alt="Made in Britain"
          data-testid="footer-made-in-britain"
          className="h-7 w-auto self-start sm:self-auto"
        />
      </div>
      <span className="tracking-[0.2em] uppercase">20-year manufacturer&apos;s warranty</span>
    </div>
  );
}
